<template>
    <v-row wrap class="ml-2 mr-0 my-0 pt-2 pb-0">
        <v-col cols="12" class="ml-1 mr-0 px-1 my-0 py-0 mt-md-2  body-2 text-truncate">
            <span v-for="(item,index) in crumpsShape"  :key="index">
                <span v-if="item.disabled" class="body-2 grey--text text--darken-2 mx-0 px-0"
                    v-html="item.text">
                </span>
                <span v-else-if="item.disableTranslated" class="body-2 grey--text text--darken-2 mx-0 px-0">
                    {{$t(item.text)}} {{item.textAdded}}
                </span>
                <router-link v-else :to="{name:item.href,params:item.params}" class="body-2 blue--text text--darken-4 mx-0 px-0">
                    {{$t(item.text)}}  {{item.textAdded}}
                </router-link>
                <span v-if="index != crumpsShape.length - 1" v-html="divider"></span>
            </span>
        </v-col>
    </v-row>
</template>
<script>
export default {
  props:['crumps'],
  data(){ return{
      crumpsShape:this.crumps,
      divider:'&nbsp;&nbsp;/&nbsp;&nbsp;',
    }
  },
  created() {
    if(this.$vuetify.breakpoint.xsOnly){
      const filters = this.$options.filters;
      var crumpsShapeData=this.crumps;
      crumpsShapeData.forEach(function(element){
        element.text = filters.shape(element.text,36);
      });
      this.crumpsShape = crumpsShapeData;
    }
  }
}

</script>
